import { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'
import { Modal } from 'antd'
import { IcoRemove } from '@/utils/icons'
import amclasses from '@pages/Admin/CRM/styles/ammodal.module.css'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import classes from './index.module.css'
import cn from 'classnames'
import { useAddAlert } from '@/hooks/useAddAlert'
import Input from '@pages/Admin/CRM/components/base/Input/Input'
import Button from '@UI/New/Button'
import { telegramBotIntegrationApi } from '@/api'
import { isError } from '@/helpers/checkQuery'
import setSettingsFromServer from '@/helpers/setSettingsFromServer'

interface ActivateTelegramBotProps {
  open?: boolean
  setOpen?: (open: boolean) => void
  necessarily?: boolean
}

const ActivateTelegramBot: FC<ActivateTelegramBotProps> = ({
  open = true,
  setOpen = () => {},
  necessarily = false,
}) => {
  const addAlert = useAddAlert()

  const userid = useSelector(selectProfile)?.id
  const [code, setCode] = useState('')
  const [isActive, setIsActive] = useState(open)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    setIsActive(open)
  }, [open])

  useEffect(() => {
    if (setOpen) {
      setOpen(isActive)
    }
  }, [isActive, setOpen])

  const handlerSubmit = async () => {
    setSubmitting(true)
    telegramBotIntegrationApi
      .activate({ user_id: userid, code: code })
      .then((res) => {
        if (isError(res)) throw new Error()
        addAlert({
          title: 'Успешно',
          text: `ТГ-Бот успешно активирован. Страница обновится через 2 секунды`,
          type: 'success',
        })
        setIsActive(false)
        setTimeout(() => window.location.reload(), 2000)
      })
      .catch((error) => {
        addAlert({
          title: 'Ошибка',
          text: 'Некорректный код активации или ошибка сервера',
          type: 'error',
        })
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return (
    <Modal
      open={isActive}
      // onOk={onSuccess}
      // onCancel={onClose}
      closable={!necessarily}
      footer={null}
      title={
        <div className={mclasses.modalHeader}>
          <p className={mclasses.modalHeaderTitle}>
            {necessarily
              ? 'Необходимо активировать ТГ-Бота'
              : 'Активировать ТГ-Бота'}
          </p>
          {!necessarily && (
            <div
              className={mclasses.closeIcon}
              onClick={() => setIsActive(false)}
            >
              <IcoRemove />
            </div>
          )}
        </div>
      }
      centered
      maskClosable
      className={cn(amclasses.modal)}
    >
      <div className={classes.description}>
        <p>
          Активируйте ТГ-бота, который будет уведомлять вас об изменениях на
          платформе.
        </p>
        <p>
          Перейдите по ссылке:{' '}
          <a
            href={`https://t.me/impulse_lms_bot?start=backend=${(new URL(window.location.origin)).hostname.toString().split('.')[0]}`}
            className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            ссылке
          </a>{' '}
          и нажмите «Начать», затем подтвердите номер телефона. После этого
          введите код подтверждения ниже.
        </p>
      </div>
      <Input
        type="number"
        placeholder="Код подтверждения"
        value={code}
        onChange={(e) => setCode(e.target.value)}
      />
      <Button
        isLoading={submitting}
        onClick={() => handlerSubmit()}
        className={classes.submitButton}
        disabled={!code || submitting}
      >
        Активировать
      </Button>
    </Modal>
  )
}

const RequiredActivateTelegramBot = () => {
  const profile = useSelector(selectProfile)
  const userRole = useSelector(selectProfile).role

  const [settings, setSettings] = useState<any | null>(null)
  const [needActivateTelegramBot, setNeedActivateTelegramBot] = useState(false)

  useEffect(() => {
    setSettingsFromServer(setSettings)
  }, [])

  useEffect(() => {
    console.log('userRole', userRole)

    if (
      !profile?.id ||
      settings?.telegramBotIntegrationEnabled !== '1' ||
      !userRole
    ) {
      setNeedActivateTelegramBot(false)
      return
    }

    switch (userRole) {
      case 'children':
        if (settings?.mandatoryTelegramBotIntegrationChildren !== '1') {
          setNeedActivateTelegramBot(false)
          return
        }
        break

      case 'parent':
        if (settings?.mandatoryTelegramBotIntegrationParent !== '1') {
          setNeedActivateTelegramBot(false)
          return
        }
        break

      default:
        if (settings?.mandatoryTelegramBotIntegrationStaff !== '1') {
          setNeedActivateTelegramBot(false)
          return
        }
        break
    }

    telegramBotIntegrationApi
      .checkIsActive({ user_id: profile?.id })
      .then((res) =>
        setNeedActivateTelegramBot(res?.data?.data?.is_active === false),
      )
      .catch(() => setNeedActivateTelegramBot(false))
  }, [
    settings?.telegramBotIntegrationEnabled,
    settings?.mandatoryTelegramBotIntegrationStudents,
    settings?.mandatoryTelegramBotIntegrationParents,
    settings?.mandatoryTelegramBotIntegrationStaff,
    profile?.id,
    userRole,
  ])

  return needActivateTelegramBot && <ActivateTelegramBot necessarily={true} />
}

export default ActivateTelegramBot
export { RequiredActivateTelegramBot }
